document.addEventListener('DOMContentLoaded', function() {
    const correctPassword = 'marianasecreto';
    const overlay = document.getElementById('secreto-overlay');

    if (!overlay) {
        return;
    }
    const form = document.getElementById('secreto-form');
    const passwordInput = document.getElementById('secreto-input');
    const errorMsg = document.getElementById('secreto-error');
    const content = document.querySelector('body');
    const authKey = 'secretoAuthTimestamp';
    const authDuration = 5 * 60 * 1000;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.removedNodes.forEach(node => {
          if (node.id === 'secreto-overlay') {
            if(content) content.style.display = 'none';
            observer.disconnect();
          }
        });
      });
    });

    const savedTimestamp = localStorage.getItem(authKey);
    if (savedTimestamp) {
      const timeSinceAuth = new Date().getTime() - savedTimestamp;
      if (timeSinceAuth < authDuration) {
        return; 
      } else {
        localStorage.removeItem(authKey);
      }
    }

    overlay.style.display = 'flex';
    setTimeout(() => {
        overlay.style.opacity = '1';
    }, 10);

    if (overlay.parentNode) {
        observer.observe(overlay.parentNode, { childList: true });
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      errorMsg.style.display = 'none';
      
      if (passwordInput.value.trim() === correctPassword) {
        localStorage.setItem(authKey, new Date().getTime());
        observer.disconnect();
        overlay.style.opacity = '0';
        setTimeout(() => {
            overlay.style.display = 'none';
        }, 400);
      } else {
        errorMsg.style.display = 'block';
        passwordInput.value = '';
      }
    });
  });